import { z } from 'zod';
import { ringCentralDataSchema } from './RingCentral';
import { fbMetricsLiveSchema } from './Facebook';

export const egressDataSchema = ringCentralDataSchema.or(
  fbMetricsLiveSchema.or(z.string()),
);

export type EgressData = z.infer<typeof egressDataSchema>;

export const egressStatusSchema = z.object({
  pixel: z.object({
    first: z.number().nullable(),
    last: z.number().nullable(),
  }),
  offlineEvent: z.object({
    first: z.number().nullable(),
    last: z.number().nullable(),
  }),
  offlineUpload: z.object({
    first: z.number().nullable(),
    last: z.number().nullable(),
  }),
  benchmarkData: z.object({
    first: z.number().nullable(),
    last: z.number().nullable(),
  }),
  lead: z.object({
    first: z.number().nullable(),
    last: z.number().nullable(),
  }),
});

export type EgressStatus = z.infer<typeof egressStatusSchema>;
